import React, { useState } from "react";
import { Container, ButtonContainer } from "./styles";

import FontLoader, { GlobalStyles } from "../styles/global";

import Selector from "../Selector";

import { iconMap } from "../../assets/icons";

export interface MitreActionsWidgetProps {
  productId: string;
  utm_source: string,
  utm_medium?: string,
  utm_campaign?: string,
  utm_term?: string,
  apiUrl: string;
  apiToken: string;
}

const MitreActionsWidget = React.forwardRef<HTMLDivElement, MitreActionsWidgetProps> (({
  productId,
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term, 
  apiUrl, 
  apiToken 
}, ref) => { 
  const [ open, setOpen ] = useState(false);

  function handleOpen() {
    setOpen(true);
  }

  function close() {
    setOpen(false);
  }

  return (
    <Container>
      <FontLoader />
      <GlobalStyles />
      {open && <Selector productId={ productId } utm_source={utm_source} utm_medium={utm_medium} utm_campaign={utm_campaign} utm_term={utm_term} apiUrl={ apiUrl } apiToken={ apiToken } close={ () => close()}/>}
      <ButtonContainer ref={ref} open={ open } onClick={() => handleOpen()}>
        <img
          src={iconMap["balloon"]}
          height={ 32 }
          width={ 32 } 
          alt="Balão com mais opções"
          draggable={ false }
        />
      </ButtonContainer> 

    </Container>
  )
});

MitreActionsWidget.displayName = "MitreActionsWidget";

export default MitreActionsWidget;